import { DefinedAmount } from ".";

export function resultIsBetter(oldLoss: DefinedAmount, newLoss: DefinedAmount) {
  // TODO: Need a more tolerant check here, as for the low amount of simulation runs the value may vary very much
  if (newLoss.avg === Infinity) {
    return false;
  }
  return newLoss.avg <= oldLoss.avg;
}
